import Cropper from 'cropperjs';
import cropHtml from './crop.component.html';

class CropController {
    constructor($scope, $timeout, $rootScope, CropService) {
        'ngInject';

        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.ready = false;
        this.service = CropService;
        this.resizeObserver = null;
        this.cropper = null

        this.$scope.safeApply = function (fn) {
            let phase = this.$root.$$phase;
            if (phase === '$apply' || phase === '$digest') {
                if (fn && (typeof (fn) === 'function')) {
                    fn();
                }
            } else {
                this.$apply(fn);
            }
        };
    }

    $onInit() {
        this.crop = {};
        this.$scope.$watch(() => this.image, () => {
            if (this.image) {
                this.$timeout(() => {
                    if (this.cropper) {
                        this.cropper.destroy();
                    }
                    this.initCropper()
                }, 500);
            }
        }, true);
    }

    initCropper() {
        const image = document.getElementById('imageCrop');
        let resizeTimeout = null;
        let containerWidth = this.getElementWidth(image.parentElement);
        let maxHeight = window.innerHeight * 0.6;

        this.cropper = new Cropper(image, {
            aspectRatio: 1,
            viewMode: 1,
            rotatable: false,
            minContainerHeight: Math.min(containerWidth, maxHeight),
            minContainerWidth: Math.min(containerWidth, maxHeight),
            responsive: false,
            autoCropArea: 1,
            checkOrientation: false,
            data: this.service.data,
            ready: () => {
                this.ready = true;
                this.$scope.safeApply();

                const observer = () => {
                    if (window.innerHeight * 0.6 === maxHeight && containerWidth === this.getElementWidth(image.parentElement) || image.parentElement.offsetWidth === 0) {
                        return;
                    }
                    containerWidth = this.getElementWidth(image.parentElement);
                    if (resizeTimeout) {
                        clearTimeout(resizeTimeout);
                    }
                    resizeTimeout = setTimeout(() => {
                        this.resizeObserver.disconnect();
                        window.removeEventListener('resize', observer);
                        this.cropper.destroy();
                        this.initCropper();
                    }, 300);
                }

                this.resizeObserver = new ResizeObserver(observer);
                this.resizeObserver.observe(image.parentElement);
                window.addEventListener('resize', observer);
            },
            cropend: () => {
                if (this.cropper.getData(true).width > 0) {
                    this.service.data = this.cropper.getData(true);
                    this.service.imageData = this.cropper.getImageData();
                } else {
                    this.service.data = null;
                    this.service.imageData = null;
                }
                this.$scope.safeApply();
            }
        });
    }

    getElementWidth(element) {
        return element.offsetWidth;
    }

    destroyCropper() {

    }
}


let cropComponent = {
    bindings: {
        image: '<',
        modal: '@'
    },
    template: cropHtml,
    controller: CropController
}

export default cropComponent;
